
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import CONSTANTS from "../../../constants";

import { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, setCodePasForAnnualService } from '../../../actions/action';

import { Input, Button, Select } from "../../Forms/Forms";
import fetchApiData from '../../apiHandlers/fetchApiData'
import vinImage from '../../../images/AP/vininfo-illustration.jpg';
import Icon from '../../buttons/Icon';
import "./serieRevision.css";
import PopUp from '../../popup/popup'
const mapStateToProps = state => state;
const mapDispatchToProps = { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, setCodePasForAnnualService };

class SerieRevision extends PureComponent {
  static defaultProps = {
    prevData: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      showKilometrage: false,
      showVinField: true,
      loading: false,
      serieInput: this.props.store.car.SerialNumber || "",
      serieCodeError: false,
      contratSerivce: false,
      kilometrageData: [],
      kilometrageSelectedValue: 0,
      showInfosSerie: false,
    };
    this.isRecallCampagneActivate = !!Number(window.siteConfig.ActivateRecallCampaign);
  }
  componentDidMount() {
    this.setState({ serieInput: this.props.store.car.SerialNumber || '' })
    if (this.props.store.car.SerialNumber !== undefined && this.props.store.car.SerialNumber.length) {
      this.checkSerieCode();
    }
  }
  checkSerieCode = () => {
    const CarDetails = new fetchApiData();
    this.setState({ loading: true });

    CarDetails.getSerie(this.state.serieInput).then(
      data => {
        switch (data.d.ErrorCode) {
          case 0:
            if (this.isRecallCampagneActivate && this.props.store.car.SerialNumber !== undefined && !this.props.store.car.SerialNumber.length) this.checkCampRapEligibility(this.state.serieInput);
            this.props.setVeiculeInfos(data.d.VehicleInfo);
            this.setState({ loading: false, serieCodeError: '', showKilometrage: true, showVinField: false });
            this.loadPas();
            break;
          default:
            this.setState({ serieCodeError: data.d.ErrorMessage })
            this.setState({ loading: false });
            break;
        }
      })
      .catch(error => {
        console.log('fait: ', error)
        this.setState({ loading: false });

      });

  }
  checkCampRapEligibility = () => {
    const cpRappelData = new fetchApiData()
    cpRappelData.getCompagneRappelEligibility(this.state.serieInput).then(
      data => {
        if (data.d.Eligible) {
          this.setState({
            showPopup: true
          });
        }
      })
      .catch(error => {
        console.log('fait: ', error)
      });

  }
  closePopup() {
    this.setState({
      showPopup: false
    });
  }
  loadPas = () => {
    const pasForfaits = new fetchApiData();
    this.setState({ loading: true });

    pasForfaits.getPas({
      "geoID": this.props.store.dealer.geoID,
      "mileage": this.props.store.kilo.kilometrage,
      "vin": this.state.serieInput
    }).then(
      data => {
        let listPas = [];
        listPas[""] = CONSTANTS.LABELS.needs_basket_maintenance_label5;
        data.d.map(function (value) {
          listPas[value.Value] = value.Text;
        });
        this.setState({ kilometrageData: listPas, loading: false });
      })
      .catch(error => {
        console.log('error getPas : ', error)

      });
  }

  render() {
    const isLoadingCssClass = (this.state.loading ? " isLoading" : "");
    const showInfosSerie = this.state.showInfosSerie;
    return (
      <div>
        <div className={"popinInfos__block popinInfos__vin"}>
          <div className="popinInfos__close" tabIndex='0'
            onKeyDown={(e) => { e.key === 'Enter' && this.props.ClosePopin() }}
            onClick={this.props.ClosePopin}>
            <Icon Name="close" />
          </div>
          {!showInfosSerie && <div className={"popinInfos__wrapper" + isLoadingCssClass}>

            <p className='popinInfos__block--title' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label1) }}></p>
            <ul className="popinInfos__block__content">
              <li className="row section-label" style={{ verticalAlign: "top" }}>

                <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label2) }}></span>
              </li>
              <li className="row section-form">
                <Input
                  placeholder={(this.props.store.car.SerialNumber !== undefined && this.props.store.car.SerialNumber.length ? this.props.store.car.SerialNumber : CONSTANTS.LABELS.needs_basket_maintenance_label3)}
                  onChange={(e) => {

                    this.setState({ serieInput: (e.target.value.trim().length ? e.target.value : '') });
                  }
                  }
                  isDisabled={(this.props.store.car.SerialNumber !== undefined && this.props.store.car.SerialNumber.length ? "disabled" : "")}
                  isInvalid={this.state.serieCodeError}
                  Selected={this.state.serieInput}
                />

              </li>

              <li className="row section-infos">
                <Icon
                  Name="info"
                  isTabIndexActivate={true}
                  onKeyDown={(e) => e.key === 'Enter' && this.setState({ showInfosSerie: (this.state.showInfosSerie ? false : true) })}
                  onClick={(e) => this.setState({ showInfosSerie: (this.state.showInfosSerie ? false : true) })}
                />
              </li>
            </ul>
            {!this.state.showKilometrage && <div className="submit-button form-wrapper">
              <Button
                onClick={() => this.checkSerieCode()}
                Disabled={this.state.serieInput.length < 8}
              >
                {CONSTANTS.LABELS.common_v2_nextstep}
              </Button>
            </div>}
            {this.state.showKilometrage && <div className="kilometrage-row">
              <ul className="popinInfos__block__content">
                <li className="row section-label" style={{ verticalAlign: "top" }}>

                  <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label4) }}></span>
                </li>
                <li className="row section-form">
                  <Select
                    Options={this.state.kilometrageData}
                    Name={CONSTANTS.LABELS.needs_basket_km}
                    onChange={(e) => {
                      this.props.setCodePasForAnnualService(e.target.value)
                      this.props.fillPasSelect({ 'selected': e.target.value, 'listPas': this.state.kilometrageData });
                      this.props.vinSuccess(true);
                    }
                    }
                    Inverse={true}
                  />

                </li>

              </ul>
            </div>}
          </div>}
          {showInfosSerie &&
            <div className="infos-wrapper section-infos">
              <div className="back-button"
                tabIndex='0'
                onKeyDown={e => e.key === 'Enter' && (this.state.showInfosSerie ?
                  this.setState({ showInfosSerie: false })
                  :
                  this.setState({ showInfosSerie: true }))
                }
                onClick={() => (this.state.showInfosSerie ?
                  this.setState({ showInfosSerie: false })
                  :
                  this.setState({ showInfosSerie: true }))
                }>
                <Icon Name="back" />{CONSTANTS.LABELS.needs_basket_maintenance_help3}
              </div>
              <div className="infos-header">
                <p>{CONSTANTS.LABELS.needs_basket_maintenance_help1}</p>
              </div>
              <div className="infos-body">
                <p>
                  <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_help2) }}></span>

                  <br />
                  <br />
                  <img src={vinImage} />
                </p>
              </div>
            </div>
          }
        </div>
        {this.state.showPopup && <PopUp title={CONSTANTS.LABELS.vehicule_step2recalleligibility}
          content={CONSTANTS.LABELS.vehicule_step2recalleligibilitycontent}
          primaryButtonLabel={CONSTANTS.LABELS.vehicule_step2recalleligibilityagreement}
          handlePrimaryButton={() => { this.closePopup() }} />}
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SerieRevision);
